import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LLPA_TYPES_ACTION_TYPE } from '../actions';

const initialState = {};

const llpaTypesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case LLPA_TYPES_ACTION_TYPE.GET_LLPA_TYPES:
        return payload || initialState;

      case LLPA_TYPES_ACTION_TYPE.CREATE_LLPA_TYPES:
      case LLPA_TYPES_ACTION_TYPE.EDIT_LLPA_TYPES:
        draft[payload.llpaTypeId] = payload;
        break;

      case LLPA_TYPES_ACTION_TYPE.DELETE_LLPA_TYPES: {
        draft[meta.llpaTypeId] = {
          ...draft[meta.llpaTypeId],
          isDeleted: true,
        };

        break;
      }

      case LLPA_TYPES_ACTION_TYPE.ENABLE_LLPA_TYPES: {
        draft[meta.llpaTypeId] = {
          ...draft[meta.llpaTypeId],
          isDeleted: false,
        };
        break;
      }

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default llpaTypesReducer;
